// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Common = require("../utils/Common.bs.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_client = require("./MM_wrk_client.bs.js");
var MM_wrk_editor = require("./MM_wrk_editor.bs.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");

var procName = "MM_wrk_LoadCtx";

function reqToStr(req) {
  return "LoadMmContext";
}

function respToStr(resp) {
  if (resp.TAG === /* MmContextLoadProgress */0) {
    return "MmContextLoadProgress(pct=" + String(resp.pct) + ")";
  } else {
    return "MmContextLoaded";
  }
}

function beginLoadingMmContext(scopes, descrRegexToDisc, labelRegexToDisc, descrRegexToDepr, labelRegexToDepr, onProgress, onDone) {
  MM_wrk_client.beginWorkerInteraction(procName, /* LoadMmContext */{
        scopes: scopes,
        descrRegexToDisc: descrRegexToDisc,
        labelRegexToDisc: labelRegexToDisc,
        descrRegexToDepr: descrRegexToDepr,
        labelRegexToDepr: labelRegexToDepr
      }, (function (resp, param, endWorkerInteraction) {
          if (resp.TAG === /* MmContextLoadProgress */0) {
            return Curry._1(onProgress, resp.pct);
          }
          Curry._1(endWorkerInteraction, undefined);
          Curry._1(onDone, resp.ctx);
        }), undefined, undefined, undefined, undefined);
}

function strToRegexOpt(str) {
  var str$1 = str.trim();
  if (str$1.length === 0) {
    return ;
  }
  var msg = Common.strToRegex(str$1);
  if (msg.TAG === /* Ok */0) {
    return Caml_option.some(msg._0);
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Could not parse a regex: " + msg._0 + ""
        },
        Error: new Error()
      };
}

function processOnWorkerSide(req, sendToClient) {
  var labelRegexToDepr = req.labelRegexToDepr;
  var descrRegexToDepr = req.descrRegexToDepr;
  var labelRegexToDisc = req.labelRegexToDisc;
  var descrRegexToDisc = req.descrRegexToDisc;
  var scopes = req.scopes;
  var totalNumOfAssertions = scopes.reduce((function (a, e) {
          return a + e.expectedNumOfAssertions | 0;
        }), 0);
  var weights = scopes.map(function (s) {
        return s.expectedNumOfAssertions / totalNumOfAssertions;
      });
  try {
    var ctx = MM_context.createContext(undefined, undefined, undefined);
    for(var i = 0 ,i_finish = scopes.length; i < i_finish; ++i){
      var scope = Caml_array.get(scopes, i);
      var basePct = weights.reduce((function(i){
          return function (a, w, idx) {
            if (idx < i) {
              return a + w;
            } else {
              return a;
            }
          }
          }(i)), 0);
      var weight = Caml_array.get(weights, i);
      MM_context.loadContext(Caml_array.get(scopes, i).ast, Caml_option.some(ctx), scope.stopBefore, scope.stopAfter, undefined, scope.expectedNumOfAssertions, strToRegexOpt(descrRegexToDisc), strToRegexOpt(labelRegexToDisc), strToRegexOpt(descrRegexToDepr), strToRegexOpt(labelRegexToDepr), (function(basePct,weight){
          return function (pct) {
            Curry._1(sendToClient, {
                  TAG: /* MmContextLoadProgress */0,
                  pct: basePct + pct * weight
                });
          }
          }(basePct,weight)), undefined, undefined);
      if (scope.resetNestingLevel) {
        while(MM_context.getNestingLevel(ctx) !== 0) {
          MM_context.closeChildContext(ctx);
        };
      }
      
    }
    Curry._1(sendToClient, {
          TAG: /* MmContextLoadProgress */0,
          pct: 1
        });
    return Curry._1(sendToClient, {
                TAG: /* MmContextLoaded */1,
                ctx: {
                  TAG: /* Ok */0,
                  _0: ctx
                }
              });
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === MM_parser.MmException) {
      return Curry._1(sendToClient, {
                  TAG: /* MmContextLoaded */1,
                  ctx: {
                    TAG: /* Error */1,
                    _0: exn._1.msg
                  }
                });
    }
    if (exn.RE_EXN_ID === Js_exn.$$Error) {
      return Curry._1(sendToClient, {
                  TAG: /* MmContextLoaded */1,
                  ctx: {
                    TAG: /* Error */1,
                    _0: Belt_Option.getWithDefault(exn._1.message, "Internal error.")
                  }
                });
    }
    throw exn;
  }
}

function getAllLabelsAfterReading(src) {
  var match = MM_wrk_editor.readInstrFromStr(src.readInstr);
  switch (match) {
    case /* ReadAll */0 :
        return [
                undefined,
                undefined,
                src.allLabels
              ];
    case /* StopBefore */1 :
        var idx = src.allLabels.findIndex(function (label) {
              return label === src.label;
            });
        if (idx !== -1) {
          return [
                  src.label,
                  undefined,
                  src.allLabels.slice(0, idx)
                ];
        } else {
          return [
                  undefined,
                  undefined,
                  src.allLabels
                ];
        }
    case /* StopAfter */2 :
        var idx$1 = src.allLabels.findIndex(function (label) {
              return label === src.label;
            });
        if (idx$1 !== -1) {
          return [
                  undefined,
                  src.label,
                  src.allLabels.slice(0, idx$1 + 1 | 0)
                ];
        } else {
          return [
                  undefined,
                  undefined,
                  src.allLabels
                ];
        }
    
  }
}

function createMmScopesForFrame(srcs, label) {
  var res = [];
  srcs.reduce((function (found, src) {
          if (found) {
            return found;
          } else {
            var match = getAllLabelsAfterReading(src);
            var allLabels = match[2];
            var match$1 = allLabels.includes(label) ? [
                label,
                undefined,
                allLabels.indexOf(label),
                false
              ] : [
                match[0],
                match[1],
                allLabels.length,
                true
              ];
            var expectedNumOfAssertions = match$1[2];
            var ast = src.ast;
            var ast$1;
            if (ast !== undefined) {
              ast$1 = ast;
            } else {
              throw {
                    RE_EXN_ID: MM_parser.MmException,
                    _1: {
                      msg: "Cannot create MM context for a frame without ast."
                    },
                    Error: new Error()
                  };
            }
            var mmScope_stopBefore = match$1[0];
            var mmScope_stopAfter = match$1[1];
            var mmScope_resetNestingLevel = match$1[3];
            var mmScope = {
              ast: ast$1,
              expectedNumOfAssertions: expectedNumOfAssertions,
              stopBefore: mmScope_stopBefore,
              stopAfter: mmScope_stopAfter,
              resetNestingLevel: mmScope_resetNestingLevel
            };
            res.push(mmScope);
            return allLabels.length !== expectedNumOfAssertions;
          }
        }), false);
  return res;
}

exports.procName = procName;
exports.beginLoadingMmContext = beginLoadingMmContext;
exports.processOnWorkerSide = processOnWorkerSide;
exports.reqToStr = reqToStr;
exports.respToStr = respToStr;
exports.createMmScopesForFrame = createMmScopesForFrame;
/* Common Not a pure module */
